import {css, StyleSheet} from 'aphrodite';
import React, {useMemo} from 'react';

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import TimingEstimateBadge from 'studies/progress/TimingEstimateBadge';
import {TimingEstimateResult} from 'studies/progress/useTimingEstimate';
import {Condition} from 'studies/typed/shared/useExperimentDesignState';
import {getProcedureRunConditionTextForProcedureType} from 'studies/TypedStudyUtils';

export function ProcedureRunConditionsSummary({
  conditions,
  estimate,
  procedureType,
}: {
  conditions: Array<Condition>;
  estimate: TimingEstimateResult;
  procedureType: ProcedureType;
}): JSX.Element {
  const numReplicates = useMemo(
    () => conditions.reduce((acc, condition) => acc + condition.numReplicates, 0),
    [conditions]
  );

  return (
    <div className={css(styles.layout)}>
      <SummaryCount
        label={getProcedureRunConditionTextForProcedureType(procedureType, {capital: true, plural: true})}
        value={conditions.length}
      />
      <SummaryCount label="Total replicates" value={numReplicates} />
      <TimingEstimateBadge estimate={estimate} action="creation" objectName="experiment" />
    </div>
  );
}

export function SummaryCount({label, value}: {label: string; value: number}): JSX.Element {
  return (
    <div className="u-flex-display">
      <div className={css(styles.label)}>{label}</div>
      <div className={css(styles.value)}>{value}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  layout: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '16px',
    paddingLeft: '16px',
  },
  label: {
    color: '#1B1B1F',
    size: '13px',
    lineHeight: '16px',
    fontWeight: 600,
    paddingRight: '4px',
  },
  value: {
    color: '#1B1B1F',
    size: '13px',
    lineHeight: '16px',
    fontWeight: 400,
  },
});
